// Single product page: material/color selection, price recalculation and add-to-cart
import { updateDisplay, createColorCustomLabelHTML } from './custom-ot';

export default function () {

    const $ = jQuery;

    function createColorLabelHTML(color, thumbnail, index, type) {
        const checked = index === 0 ? 'checked' : '';

        return `
            <label for="${color.unique}" style="background-color:${color.hex};">
              <span>${color.label}</span>
              <input type="radio"
                     name="fjs_color_options"
                     id="${color.unique}"
                     value="${color.label}"
                     data-color="${color.hex}"
                     data-type="${type}"
                     data-unique="${color.unique}"
                     ${checked}>
              ${thumbnail ? `<img src="${thumbnail}" alt="">` : ''}
            </label>
          `;
    }

    // Creates labels for Product material
    $(document).on('change', 'select[name="product_material"]', function () {
        const $opt = $(this).find('option:selected');
        const jsonStr = $opt.attr('data-json');
        const label = $opt.attr('data-label');
        const url = $opt.attr('data-url');
        const type = $opt.attr('data-type') ?? '';
        if (!jsonStr) return;

        $('.product_material_link').html('').removeClass('mt-8');

        try {
            const obj = JSON.parse(jsonStr);
            const colors = Array.isArray(obj.colors) ? obj.colors : [];
            const thumbnail = obj.thumbnail || '';

            // The main product grid (fjs_color_options) and the custom-OT grid
            // (custom_ot_select_color) are independent. A page may have either or
            // both, so fill each grid that is present instead of picking just one
            // — otherwise the custom-OT grid stays empty when both exist.
            const grids = [
                {
                    $el: $('.wc__single-product-information-color-grid'),
                    inputName: 'fjs_color_options',
                    render: (c, i) => createColorLabelHTML(c, thumbnail, i, type),
                    afterFill: null,
                },
                {
                    $el: $('.wc__single-custom-ot-color-grid'),
                    inputName: 'custom_ot_select_color',
                    render: (c, i) => createColorCustomLabelHTML(c, thumbnail, i, type),
                    afterFill: updateDisplay,
                },
            ];

            grids.forEach((grid) => {
                if (!grid.$el.length) return;

                grid.$el.html(colors.map(grid.render).join(''));

                const $colors = grid.$el.find('input[name="' + grid.inputName + '"]');
                if ($colors.length) {
                    $colors.prop('checked', false).first().prop('checked', true).trigger('change');
                }

                if (grid.afterFill) grid.afterFill();
            });

            if (label && url) {
                $('.product_material_link').append('<a class="u-inner-row u-gap-8 u-inner-align-center" href="' + url + '"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> <div>Alles over <span>' + label +'</span></div></a>').addClass('mt-8');
            }
        } catch (e) {
            console.error('Invalid data-json on selected option', e);
        }
    });

    // Changes cm
    $(document).on('change', 'select[name="product_variation"]', function () {
        let othersize = $(this).find('option:selected').data('othersize');
        $('[data-function="othersize"]').text(othersize);
    });

    // Trigger initial material selection
    $(function () {
        const $select = $('select[name="product_material"]');
        if ($select.val()) $select.trigger('change');
    });

    $(document).on('change', 'select[name="product_variation"], #plakletters, select[name="product_material"]', function () {

        let variation_id = $('select[name="product_variation"] option:selected').val();

        let jsonString = $('select[name="product_material"] option:selected').data('json');
        let obj = (typeof jsonString === "string") ? JSON.parse(jsonString) : jsonString;
        let extra_price = (obj && obj.extra_price) || 0; // fallback 0 if not found / no material json

        const isChecked = $('#plakletters').prop('checked') ? 1 : 0

        $.ajax({
            type: 'POST',
            url: ajaxURL,
            data: {
                nonce: ajaxNonce,
                action: 'recalculate_product_price',
                variation_id: variation_id,
                application: isChecked,
                extraPrice: extra_price,
            },
            beforeSend: function () {
                $('.wc__single-product-price').addClass('updating');
            },
            success: function (response) {
                if (response.success) {
                    $('.wc__single-product-price').html(response.data.price);
                }
            },
            complete: function () {
                $('.wc__single-product-price').removeClass('updating');
            }
        });

    });

    $(document).on('change', '[name="fjs_color_options"]', function () {
        const color = $(this).data('color') || $(this).val();
        const type = $(this).data('type');
        const $svg = $('.wc__single-product-main-swiper #SVG');

        if (type === 'plakletters') {
            $svg.find('path, polygon, circle, ellipse').css('fill', color);
            if (color === '#ffffff' || color === '#FFFFFF') {
                $svg.find('rect').css('fill', '#AFEBF9');
            } else {
                $svg.find('rect').css('fill', '#fff');
            }

        } else {
            $svg.find('path, polygon, rect, circle, ellipse').css('fill', color);
        }

    });


    $(document).on('click', '[data-action="add_product_to_cart"]', function (e) {
        const form = document.querySelector('.wc__single-product-sticky');

        if (!form.checkValidity()) {
            e.preventDefault();
            form.reportValidity();
            return;
        }

        let $item = $(this);
        const arr = $(form).serializeArray();
        const product = Object.fromEntries(arr.map(i => [i.name, i.value]));

        // Get unique_code from the selected radio button
        product.unique_code = $('input[name="fjs_color_options"]:checked').data('unique');

        if ($('#plakletters').length) {
            product.application_folie = $('#plakletters').prop('checked') ? 1 : 0;
        }

        let variation_id = $('select[name="product_variation"] option:selected').val();
        let jsonString = $('select[name="product_material"] option:selected').data('json');
        let obj = (typeof jsonString === "string") ? JSON.parse(jsonString) : jsonString;
        product.product_extra_price = (obj && obj.extra_price) || 0;

        $.ajax({
            type: 'POST',
            url: ajaxURL,
            data: {
                nonce: ajaxNonce,
                action: 'add_single_product_to_cart',
                product: product,
                variation_id: variation_id,
            },
            beforeSend: function () {
                $item.addClass('is-loading');
            },
            success: function (response) {
                if (response.success) {
                    window.location.href = response.data.cart_url;
                }
            },
            complete: function () {
                $item.removeClass('is-loading');
            },
        });
    });

    // Options JS
    $(document).on('click', '[data-action="add_variable_product_to_cart"]', function (e) {
        const form = document.querySelector('.wc__single-product-sticky');

        if (!form.checkValidity()) {
            e.preventDefault();
            form.reportValidity();
            return;
        }

        let $item = $(this);

        const arr = $(form).serializeArray();
        const product = Object.fromEntries(arr.map(i => [i.name, i.value]));

        $.ajax({
            type: 'POST',
            url: ajaxURL,
            data: {
                nonce: ajaxNonce,
                action: 'add_variable_single_product_to_cart',
                product: product,
            },
            beforeSend: function () {
                $item.addClass('is-loading');
            },
            success: function (response) {
                if (response.success) {
                    window.location.href = response.data.cart_url;
                }
            },
            complete: function () {
                $item.removeClass('is-loading');
            },
        });

    });

}
